import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/fonts/[font]/components/Tabs/index.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/fonts/[font]/components/Title/style.module.css");
;
import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/node_modules/next/dist/client/link.js");
